
import { setLoading } from "../generalActions/mainActions";
import { addItem, changeListItem, removeItem, setItems, setTableParams } from "../generalActions/listActions";
import { setForm, setItem } from "../generalActions/formActions";
import { typeRestrictionService } from "../../../jwt/_services/todoFluye/typeRestrictionService";

export const search = (pageIndex, pageSize, filter) => ( dispatch ) => {
    dispatch(setLoading(true))

    typeRestrictionService.search(pageIndex, pageSize, filter)
        .then(result => {
            if (!result)
                return

            dispatch(setItems(result.data))
            dispatch(setTableParams(pageSize, pageIndex, result?.total))
        })
        .finally(() => dispatch(setLoading(false)))
}

export const save = data => ( dispatch ) => {
    dispatch(setLoading(true))

    typeRestrictionService.saveItem(data)
        .then( result => {
            if(!result)
                return

            dispatch( setItem(result) )
            dispatch( setForm(false, true, true) )
            dispatch( addItem(result) )
        })
        .finally(() => dispatch(setLoading(false)))
}

export const update = (id, data) => ( dispatch ) => {
    dispatch(setLoading(true))

    typeRestrictionService.updateItem(id, data)
        .then( result => {
            if(!result)
                return

            dispatch( setItem(result) )
            dispatch( setForm(false, true, true) )
            dispatch( changeListItem(result) )
        })
        .finally(() => dispatch(setLoading(false)))
}

export const remove = (id, fbDB) => ( dispatch ) => {
    dispatch(setLoading(true))

    typeRestrictionService.deleteItem(id, fbDB)
        .then( result => {
            if(result?.status)
                dispatch( removeItem(id) )
        })
        .finally(() => dispatch(setLoading(false)))
}